
import React, { useState } from "react";
import { FaSort } from "react-icons/fa";
import SortBy from "../../Mobile Components/DailyRental/SortBy"; 

const AccesoriesSort = () => {
  const [isSortByOpen, setIsSortByOpen] = useState(false); // Manage the SortBy modal visibility

  const handleSortClick = () => {
    setIsSortByOpen(true); // Open the SortBy modal
  };

  return (
    <div className="flex items-center justify-center gap-36 w-full p-4 bg-white border shadow-sm">
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={handleSortClick} 
      >
        <FaSort className="text-xl text-black" />
        <label htmlFor="sort" className="text-black font-medium">
          SORT BY
        </label>
      </div>

      {isSortByOpen && (
        <SortBy closeModal={() => setIsSortByOpen(false)} />
      )}
    </div>
  );
};

export default AccesoriesSort;